export default __webpack_public_path__ + "static/media/001-sun.09654b2f.svg";